import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { HeaderProvider } from './contexts/HeaderContext';
import { ProfileProvider } from './contexts/ProfileContext';
import { LoadingProvider } from './contexts/LoadingContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LoadingProvider>
    <HeaderProvider>
      <ProfileProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ProfileProvider>
    </HeaderProvider>
  </LoadingProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
